import { render, staticRenderFns } from "./UpcomingCard.vue?vue&type=template&id=f276cfa2"
import script from "./UpcomingCard.vue?vue&type=script&lang=js"
export * from "./UpcomingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports